export type KnockoutRoundResult = {
  livesAtStart: number;
  livesLost: number;
  rosterId: string;
};

export const getKnockoutRoundResultDisplayScore = (
  result: KnockoutRoundResult
) => {
  const endLives = result.livesAtStart - result.livesLost;
  if (endLives <= 0) {
    return "KO";
  }

  return endLives.toString();
};

export const getKnockoutLivesLostDisplay = (result: KnockoutRoundResult) => {
  if (result.livesLost < 0) {
    return `+${result.livesLost * -1}`;
  }

  return `-${result.livesLost}`;
};
